import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const PrivacyPolicy = () => {
  return (
    <>
      <Header />

      <div
        className="container"
        style={{
          marginTop: "150px",
          marginBottom: "60px",
          maxWidth: "1000px",
        }}
      >
        {/* Hero Section */}
        <div
          className="text-center text-white p-5 rounded"
          style={{
            background:
              "linear-gradient(135deg, #6B2A00 0%, #E3952A 100%)",
          }}
        >
          <h1 className="fw-bold mb-3">Privacy Policy</h1>
          <p className="mb-0">
            Your privacy is important to us. Learn how Ez Puja Path
            collects, uses, and protects your information.
          </p>
        </div>

        {/* Content */}
        <div
          className="bg-white shadow-sm rounded p-4 p-md-5 mt-4"
          style={{
            lineHeight: "1.9",
            color: "#444",
          }}
        >
          <p>
            <strong>Last Updated:</strong> June 2026
          </p>

          <p>
            At <strong>Ez Puja Path</strong>, we value your trust and are
            committed to protecting your privacy. This Privacy Policy
            explains how we collect, use, store, and safeguard your
            personal information when you use our website and services.
          </p>

          <h3 className="mt-4">1. Information We Collect</h3>

          <p>
            We may collect the following information when you use our
            platform:
          </p>

          <ul>
            <li>Full Name</li>
            <li>Email Address</li>
            <li>Mobile Number</li>
            <li>Address and Location Information</li>
            <li>Booking and Service Details</li>
            <li>Payment Information (processed securely through payment providers)</li>
            <li>Device and Browser Information</li>
          </ul>

          <h3 className="mt-4">2. How We Use Your Information</h3>

          <p>Your information may be used to:</p>

          <ul>
            <li>Process puja and pandit bookings</li>
            <li>Provide customer support</li>
            <li>Manage user accounts</li>
            <li>Send booking confirmations and updates</li>
            <li>Improve website performance and user experience</li>
            <li>Comply with legal obligations</li>
          </ul>

          <h3 className="mt-4">3. Sharing of Information</h3>

          <p>
            We do not sell or rent your personal information. However,
            information may be shared with:
          </p>

          <ul>
            <li>Authorized pandits and service providers</li>
            <li>Payment gateway partners</li>
            <li>Technology and hosting providers</li>
            <li>Government authorities when required by law</li>
          </ul>

          <h3 className="mt-4">4. Payment Security</h3>

          <p>
            Online payments are processed through secure third-party
            payment gateways. We do not store your card details, CVV,
            UPI PIN, or banking credentials on our servers.
          </p>

          <h3 className="mt-4">5. Cookies and Tracking Technologies</h3>

          <p>
            We use cookies and similar technologies to improve website
            functionality, remember user preferences, and analyze site
            performance. For more information, please refer to our
            Cookies Policy.
          </p>

          <h3 className="mt-4">6. Data Retention</h3>

          <p>
            We retain personal information only as long as necessary to
            provide services, comply with legal requirements, resolve
            disputes, and enforce our policies.
          </p>

          <h3 className="mt-4">7. Data Security</h3>

          <p>
            We implement reasonable technical and organizational
            measures to protect your information against unauthorized
            access, disclosure, alteration, or destruction.
          </p>

          <h3 className="mt-4">8. User Rights</h3>

          <p>You may have the right to:</p>

          <ul>
            <li>Access your personal information</li>
            <li>Request correction of inaccurate information</li>
            <li>Request deletion of your data where applicable</li>
            <li>Withdraw consent for certain communications</li>
          </ul>

          <h3 className="mt-4">9. Third-Party Links</h3>

          <p>
            Our website may contain links to third-party websites. We
            are not responsible for the privacy practices or content of
            those external websites.
          </p>

          <h3 className="mt-4">10. Changes to This Privacy Policy</h3>

          <p>
            We may update this Privacy Policy from time to time. Any
            changes will be posted on this page with an updated
            effective date.
          </p>

          <h3 className="mt-4">11. Contact Us</h3>

          <p>
            If you have any questions regarding this Privacy Policy,
            please contact us:
          </p>

          <div
            className="p-4 rounded"
            style={{
              background: "#f8f9fa",
              borderLeft: "4px solid #E3952A",
            }}
          >
            <p className="mb-2">
              <strong>Ez Puja Path</strong>
            </p>

            <p className="mb-2">
              Email: info@ezpujapath.com
            </p>

            <p className="mb-2">
              Website: https://ezpujapaath.com
            </p>

            <p className="mb-0">
              Phone: +91 XXXXX XXXXX
            </p>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default PrivacyPolicy;